import { Box } from '@mui/material'
import React from 'react'
interface Props {

}
const CustomBackdrop:ReactFC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'rgba(255, 255, 255, 0.6)',
        zIndex: 900
      }}
    >
      {children}
    </Box>
  )
}
export default CustomBackdrop
